import { Modal, ModalProps } from "react-bootstrap";
import { TickSuccess } from "../icon";
import { getPortraitStageContainer } from "../PortraitStage";

interface TicketExtendedModalProps extends ModalProps {
  onHide: () => void;
}

const TicketExtendedModal = (props: TicketExtendedModalProps) => {
  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="commonModal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="text-center" style={{ padding: 48 }}>
        <TickSuccess />
        <div className="loaderTxtScan">
          Ticket <br /> Successfully Extended!
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TicketExtendedModal;
